import type { Service } from '../../graphqlTypes'

import { userFriendlyHeaderMap } from './validators'
import type {
  FormattedCsvLine,
  ValidHeader,
  ValidUserFriendlyHeader,
} from './validators'

export const getRequiredHeaders = (service: Service): ValidHeader[] => {
  if (service === 'pinterest') {
    return ['text', 'image_url', 'board_name', 'tags', 'posting_time']
  }
  return ['text', 'image_url', 'tags', 'posting_time']
}

const getOptionalHeaders = (service: Service): ValidHeader[] => {
  if (service === 'pinterest') {
    return ['title', 'alt_text', 'link']
  }
  return []
}

export const getAllHeaders = (service: Service): ValidHeader[] => {
  return [...getRequiredHeaders(service), ...getOptionalHeaders(service)]
}

export const getRequiredUserFriendlyHeaders = (
  service: Service,
): ValidUserFriendlyHeader[] => {
  return getRequiredHeaders(service).map(
    (header) => userFriendlyHeaderMap[header],
  )
}

export const getAllUserFriendlyHeaders = (
  service: Service,
): ValidUserFriendlyHeader[] => {
  return getAllHeaders(service).map((header) => userFriendlyHeaderMap[header])
}

export const getMissingHeaders = ({
  service,
  headers,
}: {
  service: Service
  headers: string[] | undefined
}): ValidUserFriendlyHeader[] => {
  const requiredHeaders = getRequiredHeaders(service)
  if (!headers || headers.length === 0) {
    return requiredHeaders.map((header) => userFriendlyHeaderMap[header])
  }
  return requiredHeaders
    .filter((header) => !headers.includes(header))
    .map((header) => userFriendlyHeaderMap[header])
}

export const getDuplicateHeaders = ({
  service,
  headers,
}: {
  service: Service
  headers: string[]
}): ValidHeader[] => {
  const allHeaders = getAllHeaders(service)
  return allHeaders.filter((validHeader) => {
    // Count how many times this validHeader appears (with or without Papa Parse suffix)
    return (
      headers.filter(
        (header) =>
          header === validHeader || header.startsWith(`${validHeader}_`),
      ).length > 1
    )
  })
}

export const isRowEmpty = (row: FormattedCsvLine): boolean => {
  return Object.values(row).every((v) => {
    return v == null || (typeof v === 'string' && v.trim() === '')
  })
}
